module.exports = __webpack_public_path__ + "img/e3.f686871a.png";